import React, {useRef, useEffect} from 'react'
import {Helmet} from 'react-helmet'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {generateRandomString} from '../../utils/utils'

const ReferralDashboard = () => {
    const {locale} = useMultiSite()
    const {data: customer} = useCurrentCustomer()
    const hasPopulated = useRef(false)

    function populateIframeSrc() {
        const baseUrl = 'https://cloud.news.delonghi.com/delonghi-together-refer'
        if (!customer?.customerId || !locale?.alias) {
            console.error('customerId or locale?.alias not available.')
        } else {
            const randomStart = generateRandomString(4)
            const randomEnd = generateRandomString(4)
            const newSrc = `${baseUrl}?id=${randomStart}${customer?.c_gigyaId}${randomEnd}&or=pa&l=${locale?.alias}`
            const iframe = document.getElementById('dynamicIframe')
            if (iframe) {
                iframe.src = newSrc
            }
        }
    }

    useEffect(() => {
        if (!hasPopulated.current && customer?.customerId && locale?.alias) {
            populateIframeSrc()
            hasPopulated.current = true
        }
    }, [customer?.customerId, locale?.alias])

    return (
        <>
            <Helmet>
                <script
                    type="text/javascript"
                    src="https://view.ceros.com/scroll-proxy.min.js"
                    data-ceros-origin-domains="sfmc-content.com"
                ></script>
            </Helmet>
            <iframe
                id="dynamicIframe"
                allow="clipboard-write; web-share"
                allowFullScreen
                src="https://cloud.news.delonghi.com/delonghi-together-refer"
                style={{
                    margin: 0,
                    padding: 0,
                    border: '0 none',
                    height: '100%',
                    width: '100%',
                    minHeight: '2000px',
                }}
                className="ceros-experience"
                title="March 2024 | De&#039;Longhi: Your Coffee Guide Copy"
            ></iframe>
        </>
    )
}

export default ReferralDashboard
